import React, { Fragment, useState } from 'react'
import useOutsideClick from 'hooks/useOutsideClick'
import { useTranslation } from 'react-i18next'
import { withRouter } from 'react-router'
import Button from 'components/Button'
import get from 'lodash/get'

import { StyledRoot, StyledActions, StyledActionLabel } from './styled'

const ItemActions = ({ actions, history, match, location, item, handlerProps }) => {
	const [showActions, setShowActions] = useState(false)
	const [showSubActions, setShowSubActions] = useState({})
	const [actionIndex, setIndex] = useState(null)

	const [t] = useTranslation()

	const actionProps = {
		data: item,
		history,
		match,
		location,
		...handlerProps
	}

	const toggleMenu = e => {
		setShowActions(prevState => !prevState)
	}

	const unmountModal = () => {
		setIndex(null)
	}
	const handleAction = ({ action, modalComponent, subActions, i }) => e => {
		if(typeof action === 'function') {
			action(actionProps)
		}
		if(modalComponent) {
			setIndex(i)
		}
		if(subActions) {
			setShowSubActions(prev => ({ ...prev, [i]: !prev[i] }))
		} else {
			setShowActions(false)
		}
	}
	const [containerRef] = useOutsideClick(() => setShowActions(false))
	const ModalComponent = get(actions, `${actionIndex}.modalComponent`)

	const renderMenu = (items, nested) => items.map((action, i) => {
		const { label, Icon, iconStyles, checkAvailability, additionalStyles, subActions } = action
		const isAvailable = typeof checkAvailability === 'function' ? checkAvailability(item, handlerProps) : true

		return(
			<div key={i}>
				<StyledActionLabel
					{ ...isAvailable && { onClick: handleAction({ ...action, i }) }}
					isAvailable={isAvailable}
					{...iconStyles && { iconStyles }}
					nested={nested}
					additionalStyles={additionalStyles}
				>
					{Icon &&
						<Icon />
					}
					{label}
				</StyledActionLabel>
				{subActions && showSubActions[i] && renderMenu(subActions, true)}
			</div>
		)
	})

	return(
		<Fragment>
			<StyledRoot ref={containerRef}>
				<Button status='dropdown' text={t('common.strings.actions')} onClick={toggleMenu}/>
				{showActions &&
					<StyledActions>
						{renderMenu(actions)}
					</StyledActions>
				}
			</StyledRoot>
			{actionIndex !== null &&
				<ModalComponent unmount={unmountModal} {...actionProps}/>
			}
		</Fragment>
	)
}

export default withRouter(ItemActions)
